import { createContext, useContext, useRef, useState } from 'react';

const EventListenerContext = createContext();

function IframeEventProvider({ children }) {
  const canvasIframeRef = useRef(null); // iframe ref

  /**
   * @description iframe 데이터를 html파일로 로컬에 저장하는 함수
   */
  const iframeHtmlExport = () => {
    if (canvasIframeRef?.current?.contentWindow) {
      let iframe = canvasIframeRef?.current?.contentWindow;
      iframe.postMessage({ parentData: 'exportData' }, '*');
      return true;
    } else {
      return false;
    }
  };

  /**
   * @description iframe 데이터를 ( 형태선택해야함 : html / json )서버에 저장하는 함수
   */
  const iframeHtmlSave = () => {
    if (canvasIframeRef?.current?.contentWindow) {
      var iframe = canvasIframeRef.current.contentWindow;
      iframe.postMessage({ parentData: 'saveData' }, '*');
    }
  };

  /**
   * @description iframe 수행했던 동작을 실행 취소하는 함수
   */
  const iframeHtmlUndo = () => {
    if (canvasIframeRef?.current?.contentWindow) {
      let iframe = canvasIframeRef?.current.contentWindow;
      iframe.postMessage({ parentData: 'undo' }, '*');
    }
  };

  /**
   * @description iframe 수행했던 동작 다시 실행하는 함수
   */
  const iframeHtmlRedo = () => {
    if (canvasIframeRef?.current?.contentWindow) {
      let iframe = canvasIframeRef?.current?.contentWindow;
      iframe.postMessage({ parentData: 'redo' }, '*');
    }
  };

  /**
   * @description iframe내의 선택된 element text를 변경하는 함수
   * @param {*} textVal 변경될 text 내용
   */
  const iframeTextChange = textVal => {
    if (canvasIframeRef?.current?.contentWindow) {
      let iframe = canvasIframeRef?.current?.contentWindow;
      iframe.postMessage({ parentData: 'text', data: textVal }, '*');
    }
  };

  /**
   * @description iframe내의 선택된 element object 형태 text를 innerHtml로 셋팅하는 함수
   * @param {*} textContent
   */
  const iframeTextContentChange = textContent => {
    if (canvasIframeRef?.current?.contentWindow) {
      let iframe = canvasIframeRef?.current?.contentWindow;
      iframe.postMessage({ parentData: 'textContent', data: textContent }, '*');
    }
  };

  /**
   * @description iframe내의 전체 크기가 변경될 때 실행하는 함수
   */
  const iframeSizeChange = () => {
    if (canvasIframeRef?.current?.contentWindow) {
      let iframe = canvasIframeRef?.current?.contentWindow;
      iframe.postMessage({ parentData: 'size' }, '*');
    }
  };

  const value = {
    canvasIframeRef,
    action: {
      iframeHtmlExport,
      iframeHtmlSave,
      iframeHtmlUndo,
      iframeHtmlRedo,
      iframeTextChange,
      iframeTextContentChange,
      iframeSizeChange,
    },
  };

  return <EventListenerContext.Provider value={value}>{children}</EventListenerContext.Provider>;
}

export const useEventListenerContext = () => useContext(EventListenerContext);
export default IframeEventProvider;
